// extracted by mini-css-extract-plugin
module.exports = {"chooseField":"chooseField__8D2KY1bH3bM4h","labelWrap":"labelWrap__++WdGrsQedVig","label":"label__YFi0Q33UzODuN"};